import { COLORS } from "../../constants";
import { LogActivity } from "../../services/users.service";
import { formatNumberToLocaleString } from "../../utils/methods";
import ActivityIcon from "../ActivityIcon";
import styles from "./styles.module.scss";

interface ActivityCardProps {
  activity: LogActivity;
  isSkipped?: boolean;
}

const ActivityCard: React.FC<ActivityCardProps> = ({ activity, isSkipped }) => {
  return (
    <div className={styles.wrapper}>
      <ActivityIcon isGrayed={isSkipped} />
      <div className={styles.contentContainer}>
        <p>{activity.type}</p>
        <span>{formatNumberToLocaleString(activity.minutes)} minutes</span>
      </div>
      <div className={styles.contentContainer}>
        <p>Source: {activity?.isTracker ? "Tracker" : "Manual"} </p>
      </div>
      <div style={{ flex: 0.5 }} className={styles.contentContainer}>
        <span
          className={styles.calorie}
          style={{ color: isSkipped ? COLORS.darkGray : COLORS.springGreen }}
        >
          {formatNumberToLocaleString(activity.calories, 1)} cal
        </span>
      </div>
    </div>
  );
};

export default ActivityCard;
